import paths, { rootPaths } from 'routes/paths';

const getStartedSteps = {
  profile: {
    id: 'profile',
    labelKey: 'setupProfile',
    titleKey: 'cm_titleProfile',
    singularKey: 'cm_singularProfile',
    navSelector: '[data-tour="tour-profile"]',
    listPath: `/${rootPaths.profileRoot}`,
    cardSelector: '[data-tour="tour-signature-card"]',
    mode: 'card'
  },
  relation: {
    id: 'relation',
    labelKey: 'createRelation',
    titleKey: 'cm_titleRelations',
    singularKey: 'cm_singularRelation',
    navSelector: '[data-tour="tour-relations"]',
    listPath: `/${rootPaths.relationsRoot}`,
    btnSelector: '[data-tour="new-relation-btn"], a[href*="new-relation"]',
    formPath: paths.newRelation,
    mode: 'wizard',
    formSelector: '.rf-accordion .rf-accordion-item, .rf-accordion-item',
    saveSelector: '[data-tour="save-btn"]'
  },
  user: {
    id: 'user',
    labelKey: 'addUser',
    titleKey: 'cm_titleUsers',
    singularKey: 'cm_singularUser',
    navSelector: '[data-tour="tour-users"]',
    listPath: `/${rootPaths.usersRoot}`,
    btnSelector: '[data-tour="new-user-btn"], a[href*="new-user"]',
    formPath: paths.newUser,
    mode: 'wizard',
    formSelector: '.rf-accordion .rf-accordion-item, .rf-accordion-item',
    saveSelector: '[data-tour="save-btn"]'
  },
  proposal: {
    id: 'proposal',
    labelKey: 'createProposal',
    titleKey: 'cm_titleProposals',
    singularKey: 'cm_singularProposal',
    navSelector: '[data-tour="tour-proposals"]',
    listPath: `/${rootPaths.proposalsRoot}`,
    btnSelector: '[data-tour="new-proposal-btn"], a[href*="new-proposal"]',
    formPath: paths.newProposal,
    mode: 'wizard',
    formSelector: '.rf-accordion .rf-accordion-item, .rf-accordion-item',
    saveSelector: '[data-tour="save-btn"]'
  },
  order: {
    id: 'order',
    labelKey: 'createOrder',
    titleKey: 'cm_titleOrders',
    singularKey: 'cm_singularOrder',
    navSelector: '[data-tour="tour-orders"]',
    listPath: `/${rootPaths.orderRoot}`,
    btnSelector: '[data-tour="new-order-btn"], a[href*="add-order"]',
    formPath: paths.newOrder,
    mode: 'wizard',
    formSelector: '.rf-accordion .rf-accordion-item, .rf-accordion-item',
    saveSelector: '[data-tour="save-btn"]'
  },
  planning: {
    id: 'planning',
    labelKey: 'createPlanning',
    titleKey: 'cm_titlePlanning',
    singularKey: 'cm_singularPlanning',
    navSelector: '[data-tour="tour-planning"]',
    listPath: `/${rootPaths.planningRoot}`,
    btnSelector: '[data-tour="new-planning-btn"]',
    formPath: null,
    mode: 'drawer',
    formSelector: '.new-planning-offcanvas.show, .offcanvas.show, .new-planning-offcanvas',
    saveSelector: '[data-tour="save-btn"]'
  }
};

export default getStartedSteps;
